import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  DemandDetails,
  DemandList,
} from 'projects/Administration/src/app/business-entities/dwo-diagnose-model';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { DwoDiagnoseBusinessService } from '../../../../../../../business-services/dwo-diagnose.service';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { DwoDiagnoseDetailsComponent } from '../dwo-diagnose-details/dwo-diagnose-details/dwo-diagnose-details.component';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as enums from 'projects/Autofacets-Core/src/app/utils/enums'

@Component({
  selector: 'app-dwo-diagnose',
  templateUrl: './dwo-diagnose.component.html',
  styleUrls: ['./dwo-diagnose.component.css'],
})
export class DwoDiagnoseComponent implements OnInit, OnDestroy {
  demandList: DemandList[];
  activeIds = [];
  id: number;
  demandDetailsList: DemandDetails[];
  editDwoDiagnose = false;
  features: Features[] = [];
  @Output() dwoData = new EventEmitter<any>();
  @ViewChildren(DwoDiagnoseDetailsComponent)
  child: QueryList<DwoDiagnoseDetailsComponent>;
  constructor(
    private service: DwoDiagnoseBusinessService,
    private readonly editAppointmentService: EditAppointmentService,
    private spinner: NgxSpinnerService,
    private cookieservice: CookieService,
    private secureStorage: SecureStorage
  ) { }

  ngOnInit(): void {
    //Check for historical WO tab -> If true then appointmentGuid will be of selected WO.
    if (
      this.editAppointmentService.isFromHistoricalWOTab ||
      this.editAppointmentService.isFromVehicleHistoricalTab
    ) {
      this.id = this.editAppointmentService.appointmentIdOfSelectedWO;
    } else {
      this.id = this.editAppointmentService.appointmentDetails.id;
    }
    this.getDemandList(this.id);
  }
  ngOnDestroy(): void {
    this.service.editFormName = '';
  }
  getDemandList(id: number) {
    this.service.getDemandList(id).then((res) => {
      this.spinner.show();
      if (res.responseObject) {
        this.demandList = res.responseObject;
        this.activeIds = Array.from(
          { length: this.demandList.length },
          (_, index) => `toggle-${index}`
        );
        if (this.demandList && this.demandList.length > 0) {
          this.service
            .getDiagnoseCauseResonList(
              this.cookieservice.get('userSelectedLanguage'),
              this.editAppointmentService.appointmentDetails.brandCode
            )
            .then((response) => {
              this.service.DiagnoseList = response.responseObject.diagnoseList;
              this.service.CauseCodeList =
                response.responseObject.causeCodeList;
              this.service.ReasonList = response.responseObject.reasonList;
              this.service.CauseList = response.responseObject.causeList;
            });
        }
      }
      this.spinner.hide();
    });
  }
  dwoDiagnoseData(event) {
    this.dwoData.emit(event);
  }
}
